import { makeBasicQueryKeys } from '@eigtech/ui-shared-api'

const { all, list } = makeBasicQueryKeys('portals')

export const portalsQueryKeys = {
  all,
  list,
  listActive: () => [...portalsQueryKeys.list(), 'active'],
}
